module.exports = __webpack_public_path__ + "img/commonwealth-office.7010660a.jpg";